/*
 * @Author: JamesWong
 * @Description: 物流配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: James Wong
 * @Last Modified time: 2019-04-19 17:44:15
 */
export default {
  receive: 'Receive',
  deliver: 'Deliver',
  inventory: 'Check/Inventory',
  createInvoice: 'Create Invoice',
  dispose: 'Dispose',
  modelDisposition: 'Model Disposition',
  modelName: 'Model Name',
  enterModelnameTips: 'Please enter Model name',
  modelId: 'Model ID',
  enterModelIdTips: 'Please enter Model ID',
  noticeName: 'Notice Name',
  noticeName1: 'StockCheck Name',
  enterNoticenameTips: 'Please enter Notice name',
  enterNoticenameTips1: 'Please enter StockCheck Name',
  noticeId: 'Notice ID',
  noticeId1: 'StockCheck ID',
  enterNoticeIdTips: 'Please enter Notice ID',
  enterNoticeIdTips1: 'Please enter StockCheck ID',
  confirm: 'Confirm',
  cancel: 'Cancel',
  noticeModelName: 'Notice Model Name',
  noticeModelId: 'Notice Model ID',
  operate: 'Operate',
  edit: 'Edit',
  delete: 'Delete',
  stockCheckPlan: 'Stock Check Analysis',
  stockCheckAnalysis: 'Stock Check Plan',
  stockChecklist: 'Stock Checklist',
  modelAddSuccess: 'Model Added',
  modelUpdateSuccess: 'Model Updated',
  deliveryNotice: 'Delivery Notice',
  replenishment: 'Replenishment'
}


// WEBPACK FOOTER //
// ./src/i18n/en/inout.js